import api from './api';

export const getItemToEdit = async (id) => {
    try {
        const response = await api.get(`/api/overtime/getSingleItemToEdit/${id}`);
        return response.data;
    } catch (error) {
        return {};
    }
};

export const updateItem = async (formData) => {
    try {
        const response = await api.put('/api/overtime/updateItem', formData);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};